import React, { SVGProps } from 'react';

const TagsFilterIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.332 3.33203H4.66536C3.92898 3.33203 3.33203 3.92898 3.33203 4.66536V7.33203C3.33203 8.06841 3.92898 8.66536 4.66536 8.66536H15.332C16.0684 8.66536 16.6654 8.06841 16.6654 7.33203V4.66536C16.6654 3.92898 16.0684 3.33203 15.332 3.33203Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.332 11.332H4.66536C3.92898 11.332 3.33203 11.929 3.33203 12.6654V15.332C3.33203 16.0684 3.92898 16.6654 4.66536 16.6654H15.332C16.0684 16.6654 16.6654 16.0684 16.6654 15.332V12.6654C16.6654 11.929 16.0684 11.332 15.332 11.332Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M6 6H6.0075" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 14H6.0075" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default TagsFilterIcon;
